import * as React from 'react';
import ErrorPage from '../components/ErrorPage';
import NotFound from '../components/NotFound';

class NotFoundPage extends React.Component {
  render() {
    return (
      <ErrorPage name="NotFound">
        <NotFound />
      </ErrorPage>
    );
  }
}

export default NotFoundPage;


// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/ErrorPages/pages/NotFoundPage.tsx